import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions";
import { ClientSchemaIdentifier } from "src/types/clientSchema";

import { useGetCaseIdentifiersQuery } from "./CaseIdentifiersQuery";
import { useGetCustomerIdentifiersQuery } from "./CustomerIdentifiersQuery";

export const useGetIdentifiersQuery = ({
  onError,
  caseTypeCode,
}: {
  onError: (error: Error) => void;
  caseTypeCode?: string;
}): {
  data: ClientSchemaIdentifier[];
  loading: boolean;
} => {
  const { hasPermission } = usePermissions();

  const caseQuery = useGetCaseIdentifiersQuery({ onError, caseTypeCode });
  const customerQuery = useGetCustomerIdentifiersQuery({
    onError,
    skip: !hasPermission(ScopeResource.CUSTOMER, Scope.VIEW),
  });
  return {
    data: [...(caseQuery.data ?? []), ...(customerQuery.data ?? [])],
    loading: caseQuery.loading || customerQuery.loading,
  };
};
